jQuery(document).ready(function(){    
    if (!sessionStorage.getItem("firsttime")) {
      sessionStorage.setItem('firsttime','no');
      window.location.reload();
    }else{
      sessionStorage.removeItem('firsttime');
    }

    $("#cart-quote").click(function(){
      $("#getQuoteForm").modal('show');
    });
    
    $('input[type=number][name="updates[]"]').keypress(function(event){    
        var keycode = (event.keyCode ? event.keyCode : event.which);    
        if(keycode == '13'){
            event.preventDefault();			
        }
    });
    
    $("#get_quote_form_btn").click(function(){
      if($("#get_quote_customer_email").val()!=""){                
          $.ajax({
          type: 'GET', 
          url: '/cart/update.js',      
          dataType: 'json', 
          success: function(cart){
            let items = cart.items;
            let data = {};
            	data['email'] = $("#get_quote_customer_email").val();
            	data['items'] = items;
              let images = [];
              data['items'] = items.map(function(item) {
                images.push(item['image']);
                return {
                    title: item['title'],
                    quantity: item['quantity'],
                    price: item['price'],
                    properties: item['properties']
                };
            });
            data['images'] = images;
              //console.log(data);
                $.ajax({
                    method: "POST",  
                    url: "https://phpstack-321644-985620.cloudwaysapps.com/Quote-from-cart.php", 
                    data: data,

                    success: function(result){           
                      if(result == "Email has sent successfully."){
                        $("#getQuoteForm .modal-header h3").html("Thank you!");
                        $('.thankyou-message').removeClass('hide');
                        $(".form-first").addClass('hide');        
                      }else{
                        $(".form-first").addClass('hide');
                        $('.error-message').removeClass('hide');
                      }
                      $("#quote_close_btn").addClass('hide');
                      $("#get_quote_form_btn").addClass('hide');
                      $('#continue_shopping_btn').removeClass('hide');
                      $('#quote_to_cart_btn').removeClass('hide');
                    }

                });  
          },
          error: function(error){
            	console.log('error', error);
          }
        });
      }      
    });
});